import { render, staticRenderFns } from "./PerRoleStats.vue?vue&type=template&id=9b4bb106&"
import script from "./PerRoleStats.vue?vue&type=script&lang=js&"
export * from "./PerRoleStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports